export default {
  email: {
    getMessage() {
      return 'validation.email';
    },
    condition(data) {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data,
      );
    },
  },
  required: {
    getMessage() {
      return 'validation.required';
    },
    condition(data) {
      return data;
    },
  },
  mask: {
    getMessage() {
      return 'validation.mask';
    },
  },
  upper: {
    getMessage() {
      return 'validation.uppercase';
    },
    condition(data, value) {
      return /[A-Z]/.test(data);
    },
  },
  lower: {
    getMessage() {
      return 'validation.lowercase';
    },
    condition(data, value) {
      return /[a-z]/.test(data);
    },
  },
  number: {
    getMessage() {
      return 'validation.number';
    },
    condition(data, value) {
      return /[0-9]/.test(data);
    },
  },
  'special-char': {
    getMessage() {
      return 'validation.special-char';
    },
    condition(data, value) {
      return /[!@#$%&]/.test(data);
    },
  },
  integer: {
    getMessage() {
      return 'validation.integer';
    },
    condition(data, value) {
      return /^\d+$/.test(data);
    },
  },
  min: {
    getMessage() {
      return 'validation.min';
    },
    condition(data, value) {
      return data.length >= value;
    },
  },
  max: {
    getMessage() {
      return 'validation.max';
    },
    condition(data, value) {
      return data.length <= value;
    },
  },
  'min-numeric': {
    getMessage() {
      return 'validation.min-numeric';
    },
    condition(data, value) {
      return data >= value;
    },
  },
  'max-numeric': {
    getMessage() {
      return 'validation.max-numeric';
    },
    condition(data, value) {
      if (Number.isNaN(data)) {
        return data.length >= value;
      }
      return parseInt(data, 10) <= value;
    },
  },
};
